<template>
  <div style="padding-top: 20px" class="about-us-wrapper">
    <section class="hero-section">
      <v-container>
        <v-row justify="center">
          <v-col cols="12" md="10" lg="9">
            <div class="hero-content">
              <h1 class="hero-title" data-aos="fade-up" data-aos-delay="100">
                Oh Yes Home Solutions
              </h1>
              <p class="hero-subtitle" data-aos="fade-up" data-aos-delay="200">
                Transforming houses into intelligent homes with AI-powered
                innovation
              </p>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <section class="content-section">
      <div class="floating-shapes">
        <div class="shape shape-1"></div>
        <div class="shape shape-2"></div>
        <div class="shape shape-3"></div>
      </div>

      <v-container>
        <v-row justify="center">
          <v-col cols="12" md="10" lg="9">
            <v-row class="mb-12">
              <v-col cols="12" md="6" data-aos="fade-right">
                <div class="feature-card">
                  <div class="feature-glow"></div>
                  <div class="feature-icon-wrapper">
                    <div class="icon-orbit"></div>
                    <v-icon color="white" size="36">mdi-rocket-launch</v-icon>
                  </div>
                  <h3 class="feature-title">Innovation First</h3>
                  <p class="feature-text">
                    We're revolutionizing home solutions with cutting-edge AI
                    technology, providing comprehensive services from
                    construction to automation.
                  </p>
                  <div class="feature-arrow"></div>
                </div>
              </v-col>
              <v-col cols="12" md="6" data-aos="fade-left">
                <div class="feature-card">
                  <div class="feature-glow"></div>
                  <div class="feature-icon-wrapper">
                    <div class="icon-orbit"></div>
                    <v-icon color="white" size="36">mdi-brain</v-icon>
                  </div>
                  <h3 class="feature-title">AI-Powered Excellence</h3>
                  <p class="feature-text">
                    Our AI systems deliver real-time responses, personalized
                    recommendations, and creative solutions tailored to your
                    unique needs.
                  </p>
                  <div class="feature-arrow"></div>
                </div>
              </v-col>
            </v-row>
            <div class="content-card" data-aos="fade-up">
              <div class="card-accent"></div>
              <h2 class="section-heading">
                <span class="heading-icon">
                  <v-icon color="#f46523" size="32">mdi-star-circle</v-icon>
                </span>
                Why Choose Us
              </h2>
              <div class="text-content">
                <p>
                  At Oh Yes Home Solutions, we are passionate about using
                  technology to improve the quality of our services. By
                  incorporating artificial intelligence into every aspect of our
                  work, we provide more accurate and efficient solutions.
                </p>
                <p>
                  Our AI-powered systems enable exceptional customer care with
                  real-time responses and personalized recommendations. This
                  helps us build stronger relationships and ensure complete
                  satisfaction.
                </p>
                <p>
                  With advanced algorithms, we create fresh and unique solutions
                  tailored to each client's requirements. Our online and mobile
                  application makes it easy to make requests and track progress,
                  earning us a reputation as industry leaders.
                </p>
              </div>

              <div class="cta-box">
                <div class="cta-content">
                  <h3 class="cta-title">Ready to Transform Your Home?</h3>
                  <p class="cta-text">
                    Join us on our journey to revolutionize the home solutions
                    industry.
                  </p>
                </div>
                <v-btn
                  large
                  depressed
                  color="#f46523"
                  dark
                  class="cta-button"
                  @click="$emit('open-contact')"
                >
                  <span>Get Started Today</span>
                </v-btn>
              </div>
            </div>
            <div class="vision-mission-grid">
              <div class="vm-card" data-aos="fade-up" data-aos-delay="100">
                <div class="vm-decoration"></div>
                <div class="vm-icon-wrapper">
                  <div class="icon-pulse"></div>
                  <v-icon color="#f46523" size="48">mdi-eye-outline</v-icon>
                </div>
                <h2 class="vm-title">Vision</h2>
                <p class="vm-text">
                  OH Yes is a digital platform connecting 10 Million customers
                  across India with verified service providers. We're your
                  personal concierge and assistant, integrating all your home
                  devices through simple Wi-Fi connectivity.
                </p>
                <p class="vm-text">
                  Achieved through IoT integration with our app - the technology
                  of tomorrow.
                </p>
                <div class="vm-badge">
                  <v-icon small color="white" class="mr-1">mdi-wifi</v-icon>
                  IoT Enabled
                </div>
              </div>

              <div
                class="vm-card mission-card"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <div class="vm-decoration"></div>
                <div class="vm-icon-wrapper">
                  <div class="icon-pulse"></div>
                  <v-icon color="#f46523" size="48">mdi-target</v-icon>
                </div>
                <h2 class="vm-title">Mission</h2>
                <p class="vm-text">
                  Mobile devices and internet have transformed how we work.
                  Today, seamless global coordination happens with just one text
                  message. We're bringing this same efficiency to home services.
                </p>
                <p class="vm-text">
                  Our platform makes professional home services as accessible as
                  sending a message.
                </p>
                <div class="vm-badge">
                  <v-icon small color="white" class="mr-1">mdi-earth</v-icon>
                  Global Standards
                </div>
              </div>
            </div>

            <v-row class="info-cards-row">
              <v-col cols="12" md="4" data-aos="zoom-in" data-aos-delay="100">
                <div class="info-card">
                  <div class="info-card-shine"></div>
                  <div class="info-card-header">
                    <div class="header-circle"></div>
                    <v-icon color="white" size="40">mdi-bullseye-arrow</v-icon>
                  </div>
                  <h3 class="info-card-title">Our Aim</h3>
                  <p class="info-card-text">
                    Providing direct employment to around 0.1 million people and
                    indirect earnings opportunities to 15,000 people through our
                    business model.
                  </p>
                  <div class="info-card-footer">
                    <div class="footer-dot"></div>
                    <span>Impact Driven</span>
                  </div>
                </div>
              </v-col>

              <v-col cols="12" md="4" data-aos="zoom-in" data-aos-delay="200">
                <div class="info-card">
                  <div class="info-card-shine"></div>
                  <div class="info-card-header">
                    <div class="header-circle"></div>
                    <v-icon color="white" size="40">mdi-account-tie</v-icon>
                  </div>
                  <h3 class="info-card-title">Service Provider</h3>
                  <p class="info-card-text">
                    Any individual or firm offering their skills or products to
                    resolve problems at your doorstep. We ensure services are
                    done properly and mutually beneficial.
                  </p>
                  <div class="info-card-footer">
                    <div class="footer-dot"></div>
                    <span>Verified Partners</span>
                  </div>
                </div>
              </v-col>

              <v-col cols="12" md="4" data-aos="zoom-in" data-aos-delay="300">
                <div class="info-card">
                  <div class="info-card-shine"></div>
                  <div class="info-card-header">
                    <div class="header-circle"></div>
                    <v-icon color="white" size="40">mdi-account-heart</v-icon>
                  </div>
                  <h3 class="info-card-title">Customer</h3>
                  <p class="info-card-text">
                    Anyone with requirements to fulfill - from appliance
                    maintenance to fitness trainers. Choose from our hub and get
                    it done in a few clicks.
                  </p>
                  <div class="info-card-footer">
                    <div class="footer-dot"></div>
                    <span>Instant Access</span>
                  </div>
                </div>
              </v-col>
            </v-row>
            <div class="team-section" data-aos="fade-up">
              <div class="section-header">
                <h2 class="section-heading-center">
                  <span class="heading-line"></span>
                  <span class="heading-text">Meet Our Leadership</span>
                  <span class="heading-line"></span>
                </h2>
                <p class="section-subheading">
                  Visionaries driving innovation in home solutions
                </p>
              </div>

              <v-row class="team-cards">
                <v-col cols="12" md="6" data-aos="flip-left">
                  <div class="team-card">
                    <div class="team-card-glow"></div>
                    <div class="team-card-header">
                      <div class="team-avatar">
                        <div class="avatar-ring"></div>
                        <v-icon size="56" color="#f46523"
                          >mdi-account-circle</v-icon
                        >
                      </div>
                      <div class="team-info">
                        <h3 class="team-name">Tinju Padmanabhan</h3>
                        <div class="team-role">
                          <v-icon small color="#f46523" class="mr-1"
                            >mdi-crown</v-icon
                          >
                          CEO & Founder
                        </div>
                      </div>
                    </div>
                    <p class="team-bio">
                      With years of experience in marketing and planning,
                      including work with RMCL NSE and BSE listed company
                      (2016-2019), and founding Indlon Farms and Developers
                      Lanka Pvt Ltd (2011-2015). Career began with a car
                      detailing center, then financial broker and franchise
                      owner with Kotak Securities (2009-2017).
                    </p>
                    <div class="team-badges">
                      <span class="badge">Marketing Expert</span>
                      <span class="badge">Serial Entrepreneur</span>
                    </div>
                  </div>
                </v-col>

                <v-col cols="12" md="6" data-aos="flip-right">
                  <div class="team-card">
                    <div class="team-card-glow"></div>
                    <div class="team-card-header">
                      <div class="team-avatar">
                        <div class="avatar-ring"></div>
                        <v-icon size="56" color="#f46523"
                          >mdi-account-circle</v-icon
                        >
                      </div>
                      <div class="team-info">
                        <h3 class="team-name">Milan Mathew</h3>
                        <div class="team-role">
                          <v-icon small color="#f46523" class="mr-1"
                            >mdi-shield-star</v-icon
                          >
                          Director
                        </div>
                      </div>
                    </div>
                    <p class="team-bio">
                      Strategic and results-driven operations and technology leader with over 22 years of global experience across Fortune 50 organizations and high-growth initiatives. Proven expertise in building scalable platforms, driving business transformation, and leveraging AI-driven automation to improve efficiency, decision-making, and customer experience.
                    </p>
                    <div class="team-badges">
                      <span class="badge">IT Strategy</span>
                      <span class="badge">Transformational Leader</span>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>
            <div class="app-download-section" data-aos="zoom-in-up">
              <div class="app-download-card">
                <div class="app-icon">
                  <v-icon color="white" size="48">mdi-cellphone-check</v-icon>
                </div>

                <div class="app-text">
                  <h2 class="app-title">Get the OhYes App</h2>
                  <p class="app-subtitle">
                    All your home services in one place
                  </p>
                </div>

                <v-form class="app-form" @submit.prevent="sendLink">
                  <div class="form-group">
                    <v-text-field
                      v-model="mobile"
                      placeholder="+91 9876543210"
                      required
                      outlined
                      dense
                      dark
                      color="white"
                      class="mobile-input"
                    ></v-text-field>
                    <v-btn
                      depressed
                      color="white"
                      class="download-btn"
                      type="submit"
                    >
                      <span style="color: #f46523; font-weight: 700"
                        >Send Link</span
                      >
                    </v-btn>
                  </div>
                </v-form>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </div>
</template>

<script>
export default {
  name: "AboutUs",
  data() {
    return {
      mobile: "",
      rules: {
        required: (value) => !!value || "Mobile number is required",
      },
    };
  },
  methods: {
    sendLink() {
      if (!this.mobile) {
        this.$emit("notify", { type: "error", message: "Enter mobile number" });
        return;
      }
      this.$emit("notify", {
        type: "success",
        message: `App link will be sent to ${this.mobile}`,
      });
      this.mobile = "";
    },
  },
};
</script>

<style scoped>
@keyframes float {
  0%,
  100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-20px);
  }
}

@keyframes gradientShift {
  0%,
  100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.05);
    opacity: 0.8;
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes shine {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

@keyframes bounce {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

@keyframes glow {
  0%,
  100% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
}

.about-us-wrapper {
  background: white;
  position: relative;
  overflow: hidden;
}

/* Hero Section */
.hero-section {
  position: relative;
  padding: 40px 0px 0px;
  overflow: hidden;
}

.hero-particles {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;

  background-size: 200% 200%;
  animation: gradientShift 20s ease infinite;
}

.hero-bg-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  pointer-events: none;
}

.hero-content {
  text-align: center;
  position: relative;
  padding-top: 10px;
  z-index: 2;
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  padding: 12px 28px;
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(20px);
  border-radius: 50px;
  border: 1px solid rgba(244, 101, 35, 0.3);
  box-shadow: 0 8px 32px rgba(244, 101, 35, 0.2);
  margin-bottom: 32px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  position: relative;
  overflow: hidden;
}

.badge-glow {
  position: absolute;
  inset: 0;

  animation: pulse 3s ease-in-out infinite;
}

.hero-title {
  font-size: 72px;
  font-weight: 900;
  background: #f46523;
  background-size: 200% 200%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 24px;
  line-height: 1.1;
  animation: gradientShift 8s ease infinite;
  letter-spacing: -2px;
}

.hero-subtitle {
  font-size: 22px;
  color: black;
  font-weight: 400;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.hero-wave {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
  line-height: 0;
}

.hero-wave svg {
  position: relative;
  display: block;
  width: calc(100% + 1.3px);
  height: 80px;
}

.wave-fill {
  fill: #0a0a0a;
}

/* Content Section */
.content-section {
  padding: 10px 0;
  position: relative;
}

.floating-shapes {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow: hidden;
  pointer-events: none;
}

.shape {
  position: absolute;
  border-radius: 50%;
  filter: blur(40px);
}

.shape-1 {
  width: 400px;
  height: 400px;
  top: 10%;
  left: -10%;
  animation: float 20s ease-in-out infinite;
}

.shape-2 {
  width: 300px;
  height: 300px;
  top: 50%;
  right: -5%;
  animation: float 15s ease-in-out infinite reverse;
}

.shape-3 {
  width: 250px;
  height: 250px;
  bottom: 20%;
  left: 50%;
  animation: float 18s ease-in-out infinite;
}

/* Feature Cards */
.feature-card {
  padding: 48px;
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(20px);
  border-radius: 32px;
  border: 1px solid rgba(244, 101, 35, 0.2);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  height: 100%;
  position: relative;
  cursor: pointer;
  overflow: hidden;
}

.feature-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  opacity: 0;
  transition: opacity 0.5s;
}

.feature-card:hover {
  transform: translateY(-12px) scale(1.02);
}

.feature-glow {
  position: absolute;
  top: -50%;
  right: -50%;
  width: 200%;
  height: 200%;
  opacity: 0;
  transition: opacity 0.5s;
}

.feature-card:hover .feature-glow {
  opacity: 1;
}

.feature-icon-wrapper {
  width: 90px;
  height: 90px;
  background: linear-gradient(135deg, #f46523 0%, #ff6b3d 100%);
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 28px;
  box-shadow: 0 12px 40px rgba(244, 101, 35, 0.4);
  position: relative;
  overflow: hidden;
}

.icon-orbit {
  position: absolute;
  inset: -2px;
  border-radius: 24px;
  background: conic-gradient(
    from 0deg,
    transparent,
    rgba(255, 255, 255, 0.3),
    transparent
  );
  animation: rotate 3s linear infinite;
}

.feature-title {
  font-size: 28px;
  font-weight: 800;
  color: black;
  margin-bottom: 16px;
  letter-spacing: -0.5px;
}

.feature-text {
  font-size: 16px;
  color: black;
  line-height: 1.8;
  margin: 0;
}

.feature-arrow {
  position: absolute;
  bottom: 24px;
  right: 24px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(244, 101, 35, 0.1);
  opacity: 0;
  transform: translateX(-10px);
  transition: all 0.4s;
}

.feature-card:hover .feature-arrow {
  opacity: 1;
  transform: translateX(0);
}

/* Content Card */
.content-card {
  padding: 64px;
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(20px);
  border-radius: 32px;
  border: 1px solid rgba(244, 101, 35, 0.2);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  margin-bottom: 80px;
  position: relative;
  overflow: hidden;
}

.card-accent {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #f46523, #ff8a5c, #f46523);
  background-size: 200% 100%;
  animation: gradientShift 3s ease infinite;
}

.section-heading {
  font-size: 36px;
  font-weight: 800;
  color: #f46523;
  margin-bottom: 40px;
  display: flex;
  align-items: center;
  gap: 16px;
}

.heading-icon {
  display: flex;
  align-items: center;
  width: 56px;
  height: 56px;
  background: rgba(244, 101, 35, 0.1);
  border-radius: 16px;
  justify-content: center;
  border: 1px solid rgba(244, 101, 35, 0.3);
}

.text-content p {
  font-size: 17px;
  color: black;
  line-height: 1.9;
  margin-bottom: 20px;
}

.cta-box {
  margin-top: 48px;
  padding: 40px;
  background: linear-gradient(
    135deg,
    rgba(244, 101, 35, 0.08) 0%,
    rgba(244, 101, 35, 0.03) 100%
  );
  border-radius: 24px;
  border: 1px solid rgba(244, 101, 35, 0.25);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 32px;
  flex-wrap: wrap;
}

.cta-title {
  font-size: 26px;
  font-weight: 800;
  color: #f46523;
  margin-bottom: 8px;
}

.cta-text {
  font-size: 16px;
  color: #f46523;
  margin: 0;
}

.cta-button {
  border-radius: 16px !important;
  padding: 0 40px !important;
  height: 56px !important;
  font-weight: 700 !important;
  text-transform: none !important;
  letter-spacing: 0.3px !important;
  font-size: 16px !important;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1) !important;
  white-space: nowrap;
  position: relative;
  overflow: hidden;
}

.cta-button::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;

  transition: left 0.5s;
}

.cta-button:hover::before {
  left: 100%;
}

.cta-button:hover {
  transform: translateY(-4px);
  box-shadow: 0 16px 50px rgba(244, 101, 35, 0.5) !important;
}

/* Vision Mission Grid */
.vision-mission-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 40px;
  margin-bottom: 80px;
}

.vm-card {
  padding: 48px;
  backdrop-filter: blur(20px);
  border-radius: 32px;
  cursor: pointer;
  border: 1px solid rgba(244, 101, 35, 0.2);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  position: relative;
  overflow: hidden;
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.vm-decoration {
  position: absolute;
  top: -50px;
  right: -50px;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  filter: blur(40px);
  transition: all 0.5s;
}

.vm-card:hover {
  transform: translateY(-12px);
  border-color: rgba(244, 101, 35, 0.4);
}

.vm-card:hover .vm-decoration {
  transform: scale(1.5);
  opacity: 0.8;
}

.vm-icon-wrapper {
  width: 100px;
  height: 100px;

  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 28px;
  border: 2px solid rgba(244, 101, 35, 0.3);
  position: relative;
  overflow: hidden;
}

.icon-pulse {
  position: absolute;
  inset: 0;
  border-radius: 24px;
  border: 2px solid rgba(244, 101, 35, 0.5);
  animation: pulse 2s ease-in-out infinite;
}

.vm-title {
  font-size: 32px;
  font-weight: 800;
  color: #f46523;
  margin-bottom: 20px;
  letter-spacing: -0.5px;
}

.vm-text {
  font-size: 16px;
  color: black;
  line-height: 1.8;
  margin-bottom: 16px;
}

.vm-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 20px;
  background: linear-gradient(135deg, #f46523 0%, #ff6b3d 100%);
  color: white;
  border-radius: 50px;
  font-size: 13px;
  font-weight: 700;
  margin-top: 20px;
  box-shadow: 0 8px 24px rgba(244, 101, 35, 0.4);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.info-cards-row {
  margin-bottom: 80px;
}

.info-card {
  padding: 40px;
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(20px);
  border-radius: 28px;
  border: 1px solid rgba(244, 101, 35, 0.2);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  height: 100%;
  display: flex;
  flex-direction: column;
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  cursor: pointer;
}

.info-card:hover {
  transform: translateY(-12px);
}

.info-card-header {
  width: 88px;
  height: 88px;
  background: linear-gradient(135deg, #f46523 0%, #ff6b3d 100%);
  border-radius: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  box-shadow: 0 12px 40px rgba(244, 101, 35, 0.4);
  position: relative;
}

.header-circle {
  position: absolute;
  inset: -4px;
  border-radius: 22px;
  border: 2px solid rgba(244, 101, 35, 0.3);
  animation: pulse 3s ease-in-out infinite;
}

.info-card-title {
  font-size: 24px;
  font-weight: 800;
  color: #f46523;
  margin-bottom: 16px;
  letter-spacing: -0.3px;
}

.info-card-text {
  font-size: 15px;
  color: black;
  line-height: 1.8;
  flex-grow: 1;
  margin-bottom: 20px;
}

.info-card-footer {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-top: 20px;
  border-top: 1px solid rgba(244, 101, 35, 0.2);
  font-size: 14px;
  font-weight: 700;
  color: black;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.footer-dot {
  width: 8px;
  height: 8px;
  background: #f46523;
  border-radius: 50%;
  box-shadow: 0 0 12px rgba(244, 101, 35, 0.6);
  animation: glow 2s ease-in-out infinite;
}

.team-section {
  margin-bottom: 80px;
}

.section-header {
  text-align: center;
  margin-bottom: 72px;
}

.section-heading-center {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  margin-bottom: 16px;
}

.heading-line {
  width: 100px;
  height: 3px;
  background: linear-gradient(90deg, transparent 0%, #f46523 100%);
  border-radius: 10px;
}

.heading-line:last-child {
  background: linear-gradient(90deg, #f46523 0%, transparent 100%);
}

.heading-text {
  font-size: 40px;
  font-weight: 900;
  color: #f46523;
  letter-spacing: -1px;
}

.section-subheading {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
  font-weight: 400;
}

.team-card {
  padding: 48px;
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(20px);
  border-radius: 32px;
  border: 1px solid rgba(244, 101, 35, 0.2);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  height: 100%;
  cursor: pointer;
  transition: all 0.5s;
  position: relative;
  overflow: hidden;
}

.team-card-glow {
  position: absolute;
  top: -100%;
  left: -100%;
  width: 300%;
  height: 300%;
  opacity: 0;
  transition: opacity 0.5s;
}

.team-card:hover .team-card-glow {
  opacity: 1;
}

.team-card:hover {
  transform: translateY(-12px);
  border-color: rgba(244, 101, 35, 0.4);
}

.team-card-header {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 28px;
}

.team-avatar {
  width: 96px;
  height: 96px;
  border-radius: 24px;
  background: linear-gradient(
    135deg,
    rgba(244, 101, 35, 0.1) 0%,
    rgba(244, 101, 35, 0.05) 100%
  );
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid rgba(244, 101, 35, 0.3);
  position: relative;
  overflow: hidden;
}

.avatar-ring {
  position: absolute;
  inset: -3px;
  border-radius: 24px;
  border: 3px solid rgba(244, 101, 35, 0.4);
  animation: pulse 2.5s ease-in-out infinite;
}

.team-name {
  font-size: 26px;
  font-weight: 800;
  color: #f46523;
  margin-bottom: 8px;
  letter-spacing: -0.5px;
}

.team-role {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 15px;
  font-weight: 600;
  color: black;
}

.team-bio {
  font-size: 15px;
  color: black;
  line-height: 1.8;
  margin-bottom: 24px;
}

.team-badges {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.team-badges .badge {
  padding: 8px 16px;
  background: rgba(244, 101, 35, 0.1);
  border: 1px solid rgba(244, 101, 35, 0.3);
  color: black;
  border-radius: 50px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.3s;
}

.team-badges .badge:hover {
  background: rgba(244, 101, 35, 0.2);
  border-color: rgba(244, 101, 35, 0.5);
  transform: translateY(-2px);
}

/* App Download Section */
.app-download-section {
  margin: 80px auto;
  display: flex;
  justify-content: center;
  padding: 0 16px;
}

.app-download-card {
  background: #f46523;
  border-radius: 24px;
  box-shadow: 0 10px 40px rgba(244, 101, 35, 0.4);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 40px;
  width: 100%;
  max-width: 900px; /* ⬅️ wider */
  min-height: 160px; /* ⬅️ shorter */
  color: white;
  flex-wrap: wrap;
}

.app-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.15);
  width: 80px;
  height: 80px;
  border-radius: 20px;
  flex-shrink: 0;
}

.app-text {
  flex: 1;
  margin-left: 24px;
  min-width: 200px;
}

.app-title {
  font-size: 22px;
  font-weight: 800;
  margin: 0 0 4px 0;
}

.app-subtitle {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  margin: 0;
}

.app-form {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  min-width: 260px;
}

.mobile-input {
  flex: 1;
  min-width: 180px;
}

.download-btn {
  border-radius: 10px !important;
  padding: 0 24px !important;
  height: 40px !important;
  text-transform: none !important;
}

@media (max-width: 960px) {
  .hero-title {
    font-size: 48px;
  }

  .hero-subtitle {
    font-size: 18px;
  }

  .stat-number {
    font-size: 32px;
  }

  .cta-box {
    flex-direction: column;
    text-align: center;
  }

  .heading-text {
    font-size: 32px;
  }

  .app-title {
    font-size: 28px;
  }

  .form-group {
    flex-direction: column;
  }

  .mobile-input {
    width: 100%;
  }
}

@media (max-width: 600px) {
  .hero-section {
    padding: 5px 0 5px;
  }

  .hero-title {
    font-size: 36px;
  }

  .content-card,
  .vm-card,
  .team-card {
    padding: 32px;
  }

  .app-download-card {
    padding: 40px 24px;
  }
}
</style>
